import { render, staticRenderFns } from "./ProcurationTemplates.vue?vue&type=template&id=0609cb77&scoped=true&"
import script from "./ProcurationTemplates.vue?vue&type=script&lang=js&"
export * from "./ProcurationTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ProcurationTemplates.vue?vue&type=style&index=0&id=0609cb77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0609cb77",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VIcon,VProgressLinear,VTextField})
